const SKILLS_DIR = ".3b/skills";

export function workflowSkillFiles(
  skillFiles: Record<string, string>
): Record<string, string> {
  const files: Record<string, string> = {};
  for (const [path, content] of Object.entries(skillFiles)) {
    files[`${SKILLS_DIR}/${path}`] = content;
  }
  return files;
}
